import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import {GameModeNames} from "../server/GameModeNames";
import {Symbol} from "../reels/Symbol";

export class CollapseRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (Game.model.gameData.nextMode.includes("_AVALANCHE") || (Game.model.gameData.brokeTheBank) || (Game.model.gameData.nextMode === GameModeNames.FREESPIN && Game.model.gameData.mayhemSpin && Game.model.monstersWithNoLife.length === 4));
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.finish();
            }
        });

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        tl.to(this, {
            duration: 0.01
        });

        tl.addLabel("hideAmount");

        if (!Game.model.gameData.brokeTheBank) {
            tl.add(() => {
                Game.keypadPlugin.setWin(Game.model.gameData.accumulatedRoundWin, true, Game.isWinBelowStake());
            }, "hideAmount");
        }
        Game.monsterReelsView.monsterSymbolContainer.children.forEach((monster: PIXI.DisplayObject) => {
            tl.add((monster as MonsterSymbol).hideAmount(), "hideAmount");
        });

        Game.isPlayMonsterDied = true;
        Game.isPlayXLootExplode = true;
        Game.isPlayHeartRestore = true;
        Game.isPlayPickupHighlight = true;
        Game.surprisedMonsters = [];
        
        // #27
        if (Game.mxSymbol) {
            Game.mxVSymbolRowIdBeforeCollapse = Game.mxSymbol.reelPosition;
            Game.mxVSymbolRowIdAfterCollapse = Game.mxSymbol.reelPosition;

            const reelsAfterAvalanche: string[][] = Game.model.gameData.reelsAfterAvalanche;

            for (let i: number = reelsAfterAvalanche[Game.mxVSymbolReelId].length - 1; i >= 0; i--) {
                if (reelsAfterAvalanche[Game.mxVSymbolReelId][i].includes("MX")) {
                    Game.mxVSymbolRowIdAfterCollapse = i;

                    break;
                }
            }
            const step: number = Game.mxVSymbolRowIdAfterCollapse - Game.mxVSymbolRowIdBeforeCollapse;

            if ((Game.mxSymbol.name === "MX_V_R")) {
                Game.reelsView.reelModels[Game.mxVSymbolReelId].mxStepInCollapse = step;
                if (Game.mxVSymbolReelId > 1) {
                    Game.reelsView.reelModels[Game.mxVSymbolReelId - 1].mxStepInCollapse = step;
                    Game.reelsView.reelModels[Game.mxVSymbolReelId - 2].mxStepInCollapse = step;
                } else if (Game.mxVSymbolReelId === 1) {
                    Game.reelsView.reelModels[Game.mxVSymbolReelId - 1].mxStepInCollapse = step;
                }
            } else if ((Game.mxSymbol.name === "MX_V_L")) {
                Game.reelsView.reelModels[Game.mxVSymbolReelId].mxStepInCollapse = step;
                if (Game.mxVSymbolReelId < Game.ACTIVE_REELS_NUM - 2) {
                    Game.reelsView.reelModels[Game.mxVSymbolReelId + 1].mxStepInCollapse = step;
                    Game.reelsView.reelModels[Game.mxVSymbolReelId + 2].mxStepInCollapse = step;
                } else if (Game.mxVSymbolReelId < Game.ACTIVE_REELS_NUM - 1) {
                    Game.reelsView.reelModels[Game.mxVSymbolReelId + 1].mxStepInCollapse = step;
                }
            }
        }

        // #30
        let monCount: number = 0;
        for (let i: number = 0; i < Game.ACTIVE_REELS_NUM; i++) {
            const symbols: Symbol[] = Game.reelsView.reelModels[i].symbols;
            for (let j: number = 0; j < symbols.length; j++) {
                const symbol: Symbol = symbols[j];
                if (Game.MONSTER_SYMBOLS.includes(symbol.name)) {
                    monCount++;

                    if (symbol.parent) {
                        symbol.parent.addChild(symbol);
                    }

                    if (monCount === Game.MONSTER_SYMBOLS.length) {
                        break;
                    }
                }
            }
            if (monCount === Game.MONSTER_SYMBOLS.length) {
                break;
            }
        }

        if (Game.monsterSymbolsGoingDead && Game.monsterSymbolsGoingDead.length) {
            tl.addLabel("hideTheDead");
            Game.monsterSymbolsGoingDead.forEach((symbol: Symbol) => {
                tl.add(() => {
                    Game.overlaysForSymbols.playBzBreak(symbol);
                }, "hideTheDead");
                tl.to(symbol.animation, {
                    duration: 20 / 30,
                    alpha: 0,
                    onComplete: () => {
                        if (symbol.parent) {
                            symbol.parent.removeChild(symbol);
                        }
                    }
                }, "hideTheDead");
            });
            tl.add(() => {
                Game.monsterSymbolsGoingDead = [];
            });
        }

        tl.addLabel("doCollapse");
        let collapseCtr: number = 0;
        for (let reelId: number = 0; reelId < Game.ACTIVE_REELS_NUM; reelId++) {
            const collapseTl: gsap.core.Timeline = Game.reelsView.reelModels[reelId].collapse(0.1 * collapseCtr);
            if (collapseTl.totalDuration()) {
                collapseCtr += 1;
            }
            tl.add(collapseTl, "doCollapse");
        }

        tl.add(Game.symbolFloors.fadeTrack(0.2, 0.4), "doCollapse");
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}